import React, { useState, useEffect } from "react"
import {
  Box,
} from '@material-ui/core';

import SelectedBlueIcon from "../../images/selected-blue.svg"

import { allQuestions } from "../../pages/Home.js"
import { DefaultContainer, TitleAndSubTitle, Stepper, Footer } from "./Step1.js"

const Step3 = ({step, setStep, reps, setReps}) => {

  return (
    <>
      <DefaultContainer>
        {/*<Stepper step={step}/>*/}

        <TitleAndSubTitle
          title={allQuestions?.step3?.title}
          subTitle={allQuestions?.step3?.subTitle}
        />

        {/* CENTER */}
        <Box sx={{flex:1, marginTop:"240px", display:"flex", justifyContent:"center", paddingLeft:"60px", paddingRight:"60px"}}>
          <Box sx={{width:"100%", display:"flex", flexDirection:"row", flexWrap:"wrap", gap:"50px", alignContent:"flex-start"}}>
            {allQuestions?.step3?.questions?.map((elem, index) => {
              let selected = false
              if (index === reps?.q3) { selected = true }
              return (
                <Box
                  key={index}
                  onClick={() => {
                    setReps({...reps, q3 : index})
                  }}
                  sx={{
                    flexBasis:'calc(50% - 25px)',
                    flexShrink:0,
                    height:"400px",
                    background: selected ? "black" : "#F3F3F6",
                    border: selected ? "4px solid black" : "3px solid #C7C4D7",
                    boxShadow: selected ? "0px 10px 30px rgba(93, 95, 239, 0.12)" : "",
                    borderRadius: "24px",
                    //cursor:"pointer",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    position:"relative"
                  }}
                >
                  {selected &&
                    <Box sx={{
                      position:"absolute",
                      width:"47px",
                      height:"47px",
                      top:"20px",
                      right:"20px",
                    }}>
                      <img src={SelectedBlueIcon} />
                    </Box>
                  }
                  <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"40px"}}>
                    <Box sx={{
                      width:"140px",
                      height:"140px",
                      background:selected ? "#4285F4" : "#E8E8EA",
                      borderRadius:"50%",
                      display:"flex",
                      justifyContent:"center",
                      alignItems:"center",
                      color: selected ? "white" : "primary.main",
                    }}>
                      {elem?.icon}
                    </Box>
                    <Box sx={{
                      fontSize:"53px",
                      fontWeight:"600",
                      color : selected ? "white" : "text.primary",
                      textAlign:"center",
                    }}>
                      {elem?.title}
                    </Box>
                    {elem?.subTitle &&
                      <Box sx={{
                        fontSize:"23px",
                        fontWeight:"500",
                        color : selected ? "white" : "#464555",
                        textAlign:"center",
                      }}>
                        {elem?.subTitle}
                      </Box>
                    }
                  </Box>
                </Box>
              )
            })}
          </Box>
        </Box>

        <Footer
          onClick={() => { setStep(4) }}
          disabled={reps?.q3 === null}
        />

      </DefaultContainer>
    </>
  );
};

export default Step3;
